/* Stylesheet */

.dropdown_menu {
  position: relative;

  .item {
    --padding-start: 21px;
    display: flex;
    --min-height: 42px;
    --color: var(--ion-color-text-secondary);
    --background: var(--ion-gradient-dark-transparent);
    --background-hover: #a3b6d3;
    font-size: 0.875rem;
    border-radius: 42px;
    box-shadow: var(--ion-box-shadow);

    .label {
      margin: 0px 4px 0px 0px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .icon {
      height: 14px;
      width: 14px;
      color: #ffffff;
    }
  }

  .active {
    border-radius: 4px 4px 0px 0px;
    --background: var(--ion-gradient-dark-transparent);
  }

  .children_container {
    position: absolute;
    min-height: 120px;
    width: 100%;
    background: var(--ion-gradient-dark-transparent);
    box-shadow: var(--ion-box-shadow);
    border-radius: 0px 0px 4px 4px;
    z-index: 100;
  }
}

/* Media Queries */
@media screen and (min-width: 1600px) {
  .dropdown_menu {
    .item {
      --min-height: 44px;
      font-size: 1rem;
    }
  }
}
